// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Home_pagination__1bnIa","containerDogs":"Home_containerDogs__T-TmP","loading":"Home_loading__2uRkr","filterTem":"Home_filterTem__iJx2X","footer":"Home_footer__1RpMR"};